import { render, staticRenderFns } from "./modalCalificacionPedido.vue?vue&type=template&id=3c3830b8&scoped=true&"
import script from "./modalCalificacionPedido.vue?vue&type=script&lang=js&"
export * from "./modalCalificacionPedido.vue?vue&type=script&lang=js&"
import style0 from "./modalCalificacionPedido.vue?vue&type=style&index=0&id=3c3830b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3830b8",
  null
  
)

export default component.exports